import api from "./index";

const employeeApi = {
  listarDropdown: async (data, token) => {
    return await api.get(`/Employee/ListDropdown`, data, token);
  }
};

export default employeeApi;